import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
//import { NotifierService } from 'angular-notifier';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private debugLevel = 0;
  constructor(
    //private notifier: NotifierService
  ) { 
    
  	if(environment.debugLevel){
  		this.debugLevel = environment.debugLevel;
  		this.log("Debuglevel set to "+this.debugLevel);
  	}
    this.log("Instantiating log-service.");
  }
  

  getDebugLevel() : number {
  	return this.debugLevel;
  }

  setDebugLevel(debugLevel : number) : void {
  	this.debugLevel = debugLevel;
  }


  log(msg : string, debugLevel? : number){
  	if(!debugLevel){
  		debugLevel = 0;
  	}
  	if(this.debugLevel > debugLevel){
  		console.log(msg);
  	}
  }

  notify(msgType:string, msg: string, id?: string){
    //this.notifier.notify(msgType,msg,id);
  }
  debug(msg : string) : void {
  	if(this.debugLevel > 0 && !environment.production){
  		console.log(msg);
  	}
  }
}
